import api from 'config/api'

import {
  ApplicationEntryEditFormProps,
  ApplicationEntryFormProps,
  partnerCompanyProps,
} from 'types/med'
import { client } from 'app/client'

export const getMedicalInstitutionList = () =>
  client<ApplicationEntryFormProps[]>(api.applicationInstitutions)

export const getPartnerCompanies = () =>
  client<partnerCompanyProps[]>(api.partnerCompanies)

export const getMedicalInstitution = ({
  institution_id,
}: {
  institution_id: partnerCompanyProps['id']
}) =>
  client<ApplicationEntryFormProps>(
    `${api.applicationInstitutions}/${String(institution_id)}`
  )

export const putMedicalInstitution = ({
  institution_id,
  data,
}: {
  institution_id: partnerCompanyProps['id']
  data: ApplicationEntryEditFormProps
}) =>
  client<void>(
    `${api.applicationInstitutions}/${String(institution_id)}`,
    data,
    'PUT'
  )

export const deleteMedicalInstitutionProps = ({
  institution_id,
}: {
  institution_id: partnerCompanyProps['id']
}) =>
  client<void>(
    `${api.applicationInstitutions}/${String(institution_id)}`,
    {},
    'DELETE'
  )

export const resendMail = (institution_id: ApplicationEntryFormProps['id']) =>
  client<void>(`${api.resendInstitutionMail}/${String(institution_id)}`)
